export default __webpack_public_path__ + "static/media/website.8fd5b983.png";